import React from "react";
import { ExternalLink } from "react-feather";

// Access Guide (2026-09-17): a plain-English manual of every permission, for the
// people who set up users. The guide itself is a standalone page shipped in
// public/access-guide.html (built from the live roles and designations), shown
// here inside the admin layout, with a link to open it full screen or print it.
const GUIDE_URL = `${process.env.PUBLIC_URL || ""}/access-guide.html`;

const AccessGuidePage = () => (
  <div className="page-wrapper">
    <div className="content">
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>Access Guide</h4>
            <h6>What every permission does, and which ones to give for each job</h6>
          </div>
        </div>
        <div className="page-btn">
          <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer"
            className="btn btn-outline-primary d-inline-flex align-items-center gap-1">
            <ExternalLink size={15} /> Open full screen
          </a>
        </div>
      </div>
      <iframe
        title="Access Guide"
        src={GUIDE_URL}
        style={{ width: "100%", height: "calc(100vh - 190px)", minHeight: 480, border: "1px solid #e7e0e1", borderRadius: 8, background: "#fff" }}
      />
    </div>
  </div>
);

export default AccessGuidePage;
